// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardActionArea {
  width: fit-content;
  border-radius: 0.5rem;
  margin-top: 0.2rem;
}

.rectangleBox {
  display: flex;
  align-items: center;
  justify-content: start;
  border-radius: 0.5rem;
  padding: 0.3rem 0.5rem;
  width: fit-content;
  min-width: 135px;
  gap: 0.5rem;
  cursor: pointer;
  overflow: hidden;
}
.rectangleBox .square {
  width: 12px;
  height: 12px;
  border-radius: 0.1rem;
}

.squareActive {
  transform: scale(50);
  transition: all ease 1s;
}

.squareDiActive {
  transform: scale(1);
  transition: all ease 0.5s;
}

.animationRectangle {
  transition: all ease-in 0.5s;
}

.labelStyle {
  position: relative;
  z-index: 2;
  transition: all ease 0.25s;
}`, "",{"version":3,"sources":["webpack://./src/components/ResutTest/RectangleBox/rectangle.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,qBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AAEI;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AAAR;;AAIA;EACI,oBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,mBAAA;EACA,yBAAA;AADJ;;AAKA;EACI,4BAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,UAAA;EACA,0BAAA;AAFJ","sourcesContent":["\n.cardActionArea {\n    width: fit-content;\n    border-radius: 0.5rem;\n    margin-top: 0.2rem;\n}\n\n.rectangleBox {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    border-radius: 0.5rem;\n    padding: 0.3rem 0.5rem;\n    width: fit-content;\n    min-width: 135px;\n    gap: 0.5rem;\n    cursor: pointer;\n    overflow: hidden;\n\n    .square {\n        width: 12px;\n        height: 12px;\n        border-radius: 0.1rem;\n    }\n}\n\n.squareActive {\n    transform: scale(50) ;\n    transition: all ease 1s;\n}\n\n.squareDiActive {\n    transform: scale(1) ;\n    transition: all ease 0.5s;\n}\n\n\n.animationRectangle {\n    transition: all ease-in 0.5s;\n}\n\n.labelStyle {\n    position: relative;\n    z-index: 2;\n    transition: all ease 0.25s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
